import { Link } from 'react-router-dom';
import {
  Wifi,
  ExternalLink,
  ImageIcon,
  KeyRound,
  DollarSign,
  ShieldAlert,
  Layers,
  Inbox,
  FileText,
} from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

export function Dashboard() {
  const tools = [
    {
      name: 'WebSocket Tester',
      description: 'Test WebSocket connections and real-time streaming',
      path: '/dev-console/websocket-tester',
      icon: Wifi,
    },
    {
      name: 'Arche Icon Manager',
      description: 'Upload and manage icons for arches',
      path: '/dev-console/arche-icons',
      icon: ImageIcon,
    },
    {
      name: 'Beta Key Manager',
      description: 'Generate and manage invite keys for closed beta participants',
      path: '/dev-console/beta-keys',
      icon: KeyRound,
    },
    {
      name: 'Payments & Revenue',
      description: 'Platform economics, revenue, costs, refunds, and user management',
      path: '/dev-console/payments',
      icon: DollarSign,
    },
    {
      name: 'Arche Management',
      description: 'Manage featured arches and per-arche suggested arches',
      path: '/dev-console/arche-management',
      icon: Layers,
    },
    {
      name: 'Plugin Review Queue',
      description:
        'Review escalated plugin submissions — approve to release the build, or reject with notes',
      path: '/dev-console/admin/reviews',
      icon: Inbox,
    },
    {
      name: 'My Submissions',
      description: 'Track the review and build status of every arche you have submitted',
      path: '/dev-console/submissions',
      icon: FileText,
    },
    {
      name: 'Maintenance Mode',
      description: 'Emergency kill switch — take the platform offline for all non-admin users',
      path: '/dev-console/maintenance',
      icon: ShieldAlert,
    },
  ];

  return (
    <div className="max-w-4xl mx-auto p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground">Dev Console</h1>
        <p className="mt-2 text-muted-foreground">
          Development tools for testing and previewing Fias components
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {tools.map((tool) => {
          const IconComponent = tool.icon;
          return (
            <Link key={tool.path} to={tool.path}>
              <Card className="h-full transition-shadow hover:shadow-lg">
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="text-primary">
                      <IconComponent className="h-8 w-8" />
                    </div>
                    <div>
                      <CardTitle className="text-lg">{tool.name}</CardTitle>
                      <CardDescription className="mt-1">{tool.description}</CardDescription>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Link>
          );
        })}
      </div>

      <Card className="mt-12 bg-muted/50">
        <CardHeader>
          <CardTitle className="text-lg">Quick Links</CardTitle>
          <div className="flex flex-wrap gap-4 mt-4">
            <a
              href="/v1/entities"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary hover:underline text-sm"
            >
              API: List Entities
              <ExternalLink className="h-3 w-3" />
            </a>
            <a
              href="/v1/categories"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary hover:underline text-sm"
            >
              API: List Categories
              <ExternalLink className="h-3 w-3" />
            </a>
            <a
              href="/v1/arches"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary hover:underline text-sm"
            >
              API: List Arches
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </CardHeader>
      </Card>
    </div>
  );
}

export default Dashboard;
